<template>
  <div id="dashboard" class="">
    <div id="fondo">
      <div class="container">
        <div class="row">
          <div class="col-12 h-100 py-4">&nbsp;</div>
          <div class="col-12 h-100 py-4">&nbsp;</div>
        </div>

        <div class="row pt-5 bgpestana">
          

          <div class="col-12 pb-5 z100">
            <!-- <p class="fXG text-center bold pb-4 blanco">
            ¡Hola
            <span class="blanco">{{ userProfile.nombre }}</span
            >!s
          </p> -->

            <p class="fXG blanco text-center p-5">
              <img src="../assets/imgs/dominos/registra-tu-ticket-y suma-goles.png" class="w-100 tituloseccion" alt="Domino's Pizza">
            </p>

           

            <!-- <div class="text-center fXG pb-5" v-if="userProfile.ultimo_ticket_registrado != ''  && userProfile.puntos_acumulados < 100  && userProfile.puntos_acumulados > 0">
              ¡Cuentas con {{ userProfile.puntos_acumulados }} puntos! Junta 100
              puntos para poder participar en nuestra trivia y ganar increíbles
              premios.
            </div> -->

            <!-- <div
              class="text-center  pb-5"
              v-if="
                userProfile.ultimo_ticket_registrado != '' &&
                userProfile.puntos_acumulados >= 100
              "
            >
              <div class="pb-3 fXG">
                ¡Cuentas con <strong class="bold">{{ userProfile.puntos_acumulados }} puntos</strong>, ya puedes participar en nuestra trivia para ganar increíbles
                premios!
              </div>
              <div class="pb-3">
                (Estos puntos se sumarán al puntaje que obtengas en la trivia, aumentando la posibilidad de ganar.)
              </div>

              <div class="px-2 text-center d-flex align-items-center">
                <button
                  @click="jugar()"
                  class="
                    btnaction
                    pointer
                    d-flex
                    align-items-center
                    justify-content-center
                    btnaction
                    fG
                    ml-auto
                    mr-auto
                    w-100
                    bold
                  "
                >
                  JUGAR AHORA
                </button>
              </div>
              <div class="pt-5 pb'4">
                ó
              </div>
            </div> -->

            <p class="fG text-center blanco">
              <!-- <span class="">Para comenzar sube una foto</span> de tu <span class="amarillo bold">ticket de compra</span>. -->

              <img
                src="../assets/imgs/dominos/icono-foto.png"
                alt="Subir ticket"
                class="img-fluid pointer py-4"
                @click="$refs.file.click()"
                v-if="file == null"
              />
            </p>

            <div
              class="col-12 text-center d-flex justify-content-center align-items-center"
            >
              <input
                type="file"
                class="hidden"
                ref="file"
                @change="fileSelected"
                accept="image/*"
                capture
              />
            </div>

            <div class="w-100 text-center px-5">
              <div
                class="px-2 text-center d-flex align-items-center"
                v-if="file == null"
              >
                <button
                  @click="$refs.file.click()"
                  class="btnaction pointer fG px-5 bold"
                >
                  SUBIR FOTO DE TICKET
                </button>
              </div>

              <div class="py-3 mb-2">
                <div id="preview"></div>
              </div>

              <div class="col-12 pb-2">
                <div
                  class="text-center d-flex align-items-center"
                  v-if="file != null"
                >
                  <button
                    @click="tomarTrivia()"
                    class=" pointer d-flex align-items-center justify-content-center btnaction2 fG ml-auto mr-auto w-100 bold"
                  >
                    Continuar
                  </button>
                </div>
              </div>

              <div class="row">
                <div class="col-10 offset-1">
                  <p class="blanco text-center pb-5">
                    *Formatos permitidos: JPG, PNG
                  </p>

                  <p class="blanco text-center fG bold">
                    Cada $1 peso de tu ticket = 1 punto.
                  </p>

                  <p class="blanco text-center fG">
                    Entre más tickets registres, más subes en la tabla.
                  </p>

                  
                </div>
              </div>

              <!-- <router-link to="/mis-participaciones" class="btnaction2 fG mb-5">
                Ver mis puntos acumulados
              </router-link> -->

              <div class="row">
                <div class="col-12 py-5">
                  &nbsp;
                </div>
              </div>

            </div>
          </div>
          <!-- termina fondo azul -->
        </div>
      </div>
    </div>

    <div class="container"></div>

    <Footer></Footer>

    <div
      class="overlayticket overlay-sucursal"
      v-if="overlay_sucursal === true"
    >
      <div class="bg-overlay" @click="toggleSucursal"></div>
      <div class="ticket shadow rounded bg-moradooscuro">
        <div class="head">
          <div
            class="cerrar p-2 d-block fG pointer amarillo monts"
            @click="toggleSucursal"
          >
            cerrar
          </div>
        </div>
        <div class="body text-center w-100">
          <div class="titulo fG amarillo bold">Número de sucursal:</div>
          <img
            class="img-fluid p-4"
            src="../assets/imgs/homeins/ticket-sucursal.jpg"
            alt="Domino's Pizza"
          />
        </div>
      </div>
    </div>

    <div
      class="overlayticket overlay-sucursal"
      v-if="overlay_transaccion === true"
    >
      <div class="bg-overlay" @click="toggleTransaccion"></div>
      <div class="ticket shadow rounded bg-moradooscuro">
        <div class="head">
          <span
            class="cerrar p-2 d-block fG pointer amarillo monts"
            @click="toggleTransaccion"
            >cerrar</span
          >
        </div>
        <div class="body text-center w-100">
          <div class="titulo fG amarillo bold">Número de trnsacción:</div>
          <img
            class="img-fluid p-4"
            src="../assets/imgs/homeins/ticket-transaccion.jpg"
            alt="Domino's Pizza"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commentsCollection } from "@/firebase";
import { mapState } from "vuex";
import moment from "moment";
import AOS from "aos";
import swal from "sweetalert2";

import Footer from "@/components/Footer";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      post: {
        content: "",
      },
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      postComments: [],
      file: null,
      monedero: "",
      no_transaccion: null,
      no_sucursal: null,
      disponibles: [
        "merida",
        "fantasma",
        "forrest",
        "gladiador",
        "id4",
        "lalaland",
        "malefica",
        "parque-jurasico",
        "psicosis",
        "pulp",
        "et",
        "chucky",
        "diario",
        "wolverine",
        "piratas",
        "peterpan",
        "titanic",
        "lord",
        "karate",
        "silencio",
        "kill",
        "godfather",
        "resplandor",
        "mary",
        "mago",
        "blackpanther",
        "corazon",
        "inception",
        "harry",
        "simpsons",

        "aladino",
        "alicia",
        "alien",
        "ava",
        "baby",
        "batman",
        "bella",
        "ben",
        "big",
        "blancanieves",

        "buscando",
        "capitan",
        "car",
        "cenicienta",
        "coco",
        "dama",
        "dirty",
        "dracula",
        "emperor",
        "escuadron",

        "exorcista",
        "froz",
        "hombres",
        "home",
        "hunger",
        "ice",
        "increibles",
        "indiana",
        "iron",
        "it",

        "kung",
        "lilo",
        "mati",
        "matrix",
        "mega",
        "mision",
        "moa",
        "monsters",
        "mulan",
        "naufrago",

        "nosotros",
        "pesadilla",
        "picapiedra",
        "pino",
        "poca",
        "quien",
        "quinto",
        "rapsodia",
        "rata",
        "reyleon",

        "rock",
        "sabueso",
        "scooby",
        "shrek",
        "sirenita",
        "spiderman",
        "starwars",
        "super",
        "tarzan",
        "termi",

        "thor",
        "tiburon",
        "tomb",
        "top",
        "toy",
        "trans",
        "up",
        "vase",
        "villano",
        "volver",

        "wall",
        "wonder",
      ],
      dulceria: [
        "dulceria1",
        "dulceria2",
        "dulceria3",
        "dulceria4",
        "dulceria5",
        "dulceria6",
        "dulceria7",
        "dulceria8",
        "dulceria9",
        "dulceria10",
        "dulceria11",
      ],
      overlay_transaccion: false,
      overlay_sucursal: false,
    };
  },
  computed: {
    ...mapState(["userProfile", "posts"]),
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    console.log({'user profile': this.userProfile.email});
  },
  methods: {
    // async jugar() {
    //   this.$store.commit(
    //     "setTicketID",
    //     this.userProfile.ultimo_ticket_registrado
    //   );
    //   this.$router.push("/dinamica");
    // },
    fileSelected: function ($event) {
      this.file = $event.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {
        // get loaded data and render thumbnail.
        var preview = document.getElementById("preview");
        var image = document.createElement("img");
        image.src = e.target.result;
        preview.innerHTML = "";
        preview.appendChild(image);
        console.log(preview);

        // swal.fire(
        //   "Bien",
        //   "Recuerda conservar tus tickets de compra, da click en continuar para participar.",
        //   "success"
        // );
      };

      // read the image file as a data URL.
      reader.readAsDataURL(this.file);
    },
    async tomarTrivia() {
      if (this.file == null) {
        swal.fire(
          "Oops",
          "Sube la foto de un ticket antes de continuar...",
          "warning"
        );
        return;
      }

      let ticket_obj = await this.$store.dispatch("registroTicket", {
        file: this.file,
      });

      this.uploadVeryfi(ticket_obj);

      this.file = null;
      var preview = document.getElementById("preview");
      preview.innerHTML = "";
    },
    uploadVeryfi(ticket_obj) {
      const https = require("https");
      var qData = {
        img_url: ticket_obj.ticket_img_url,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL +
            "main-monto-datumax.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            // console.log("VERYFI RESPONSE");
            // console.log(response);

            let res = response.body;
            let resactualiza = await this.$store.dispatch(
              "actualizaTicketVeryfi",
              {
                ticket_ocr: res.response,
                //ticket_ocr: "{'invoice_number':'101010101'}",
                ticket_obj: ticket_obj,

                validacion: res.validacion,
                validacion_prods_participantes:
                  res.validacion_prods_participantes,
                validacion_fecha: res.validacion_fecha,
                validacion_tienda: res.validacion_tienda,
                invoice_duplicado: res.invoice_duplicado,
                validacion_monto: res.validacion_monto,
                monto_productos_participantes:
                  res.monto_productos_participantes,
                puntos: res.puntos

                // validacion: "valido",
                // validacion_prods_participantes: "valido",
                // validacion_fecha: "valido",
                // invoice_duplicado: "valido",
                // validacion_monto: "valido",
                // monto_productos_participantes: 51,

                //coca_sin_azucar: res.coca_sin_azucar,
                //cashi: res.cashi,
                //socio_plus: this.socio_plus,
              }
            );

            if (resactualiza === "ok") {
              this.$router.push("/ticket-ok");
            } else {
              swal.fire(
                "Oops",
                "El ticket que has registrado es inválido, verifica los datos de tu ticket e intenta subirlo nuevamente, la foto debe ser nítida y contener el ticket completo no. de ticket, fecha y productos participantes.",
                "warning"
              );
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            swal.fire(
              "Oops",
              "Hubo un error al momento de subir tu ticket, por favor intenta de nuevo.",
              "warning"
            );
            this.$store.dispatch("showLoader", false);
          }
        );
    },
    toggleSucursal() {
      this.overlay_sucursal = !this.overlay_sucursal;
    },
    toggleTransaccion() {
      this.overlay_transaccion = !this.overlay_transaccion;
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>

<style lang="scss" scoped>
.overlayticket {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100000;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  .bg-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
  }
  .ticket {
    width: 50%;
    margin: 0 25%;
    .head {
      width: 100%;
      .cerrar {
        text-align: right;
        cursor: pointer;
        user-select: none;
      }
    }
    .body {
    }
  }
}
</style>
